var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('TagHeader',{attrs:{"title":_vm.title,"buttons":_vm.buttons}}),_c('ForgotPasswordContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }